import request from '@/utils/httpRequest'

export default class ArchiveInfoService {
    queryById(id) {
        return request({
            url: '/archive/wuyeArchiveInfo/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/archive/wuyeArchiveInfo/startFlow',
            method: 'post',
            data: params
        })
    }

}
